import React from 'react';
import { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-label';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  ALIGN,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';

import SvgIconLoader from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';
import {
  CUSTOM_LINK_CONTENT,
} from '@bit/gerenciatd.utils.tagging';
import ProductFeatureDetailContent from './ProductFeatureDetailContent';
import { VARIANT } from '../../index';
import { iconsFeature } from '../../../../constants/iconsFeature';
import {
  getSvgIconColor,
} from '../../Utils/index';
import './ProductFeatureDetail.scss';

export const ProductFeatureDetail = ({
  feature,
  variant,
  handleClickIncludes,
  calculatedTaggingInfo,
  modifierSmartphoneIncludes,
  hiredProductWeights,
  dicRepoProductWeights,
  hideColors,
  featureType,
}) => {
  return (
    <div className="ProductFeatureDetail">
      <CustomLink
        onClick={handleClickIncludes}
        taggingInfo={{
          ...calculatedTaggingInfo,
          componentContent: CUSTOM_LINK_CONTENT.DEFAULT,
        }}
      >
        <span
          className={`ProductFeatureDetail${featureType}`}
        >
          <SvgIconLoader
            id={iconsFeature[feature.icon]}
            size={32}
            kind={SVG_ICON_KIND.LIGHT}
            color={getSvgIconColor(variant)}
            className="svg-icon-loader"
          />
          <div>
            {feature.alias.includes('ic_movil') && (
            <div className="text-info-wrapper">
              <TextInfo
                text={feature.title}
                kind={KIND_TEXT.PARAGRAPH}
                align={ALIGN.LEFT}
                color={COLOR.BLACK}
                size={SIZE.CAPTION1}
                fontType={FONT_TYPE.REGULAR}
              />
            </div>
            )}

            <ul>
              {feature.alias.includes('ic_smartphone') && modifierSmartphoneIncludes && (
                <TextInfo
                  text={modifierSmartphoneIncludes}
                  kind={KIND_TEXT.PARAGRAPH}
                  align={ALIGN.LEFT}
                  color={
                       variant === VARIANT.HIRED
                         ? COLOR.BLACK
                         : COLOR.GREY_6
                     }
                  size={SIZE.CAPTION2}
                  fontType={FONT_TYPE.REGULAR}
                />
              )}
              {!(feature.alias.includes('ic_smartphone') && modifierSmartphoneIncludes) && (
                feature.commerInfo.map((aggr) => {
                  return (
                    <ProductFeatureDetailContent
                      aggr={aggr}
                      hideColors={hideColors}
                      variant={variant}
                      hiredProductWeights={hiredProductWeights}
                      dicRepoProductWeights={dicRepoProductWeights}
                    />
                  )
                })
              )
              }

            </ul>
          </div>
        </span>
      </CustomLink>
    </div>

  )
}

export default ProductFeatureDetail;
